import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=36cfc3c7&scoped=true"
import script from "./Persons.vue?vue&type=script&lang=js"
export * from "./Persons.vue?vue&type=script&lang=js"
import style0 from "./Persons.vue?vue&type=style&index=0&id=36cfc3c7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cfc3c7",
  null
  
)

export default component.exports